import * as types from './actionTypes';

export function setGlobalErrors(filter, {status = 200, error = null}) {
    return {
        type: types.SET_GLOBAL_ERRORS,
        filter,
        status,
        error,
    }
}

export function clearGlobalErrors() {
    return {
        type: types.CLEAR_GLOBAL_ERRORS,
    }
}


// WEBPACK FOOTER //
// ./src/actions/globalErrorActions.js